(function navmainocScript($, Drupal) {
    Drupal.behaviors.navmainoc = {
        attach: function (context, settings) {
            $('.nav-main-oc .nav-main__item--has-children .nav-main__a').on('click', function () {
                let parentLi = $(this).parent();
                $(parentLi).toggleClass('clicked');
                if ($(parentLi).hasClass('clicked')) {
                    event.preventDefault();
                    $(parentLi).children('.nav-main__lvl2').addClass('active');
                }
            });
        },
    };
}(jQuery, Drupal));
